/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Section_InventoryInputs */

const cs_nav_section_inventory = /** @type {(inputs: Nav_Section_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabídka`)
};

const en_nav_section_inventory = /** @type {(inputs: Nav_Section_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inventory`)
};

/**
* | output |
* | --- |
* | "Inventory" |
*
* @param {Nav_Section_InventoryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_section_inventory = /** @type {((inputs?: Nav_Section_InventoryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Section_InventoryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_section_inventory(inputs)
	return cs_nav_section_inventory(inputs)
});